exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sensitive-words-modal .sensitive-aui-svg-size[data-v-77ea9160]{fill:#1890ff;position:absolute;top:-29px;font-size:18px}.sensitive-words-modal .sensitive-words-modal-div[data-v-77ea9160]{margin:5px 0}.sensitive-words-modal .sensitive-words-modal-red[data-v-77ea9160]{color:#f5222d}.sensitive-words-modal[data-v-77ea9160] .aui-grid-modal__header .aui-grid-modal__title{margin-left:25px}.sensitive-words-modal .sensitive-words-modal-title[data-v-77ea9160]{font-weight:700;font-size:16px}", ""]);

// exports
